import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-ext-500.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/latin-ext-700.css';
import App from './App';
import KioskPage from './modules/plant-maintenance/KioskPage';

// /kiosk is the ONLY public page: the QR label on a machine opens it for operators WITHOUT a
// portal login (token-guarded server-side, see backend routes-kiosk.js). Branching here keeps
// the whole authenticated App untouched — the kiosk never sees session state.
const isKiosk = window.location.pathname === '/kiosk';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isKiosk ? <KioskPage /> : <App />}
  </React.StrictMode>
);
